<script>
export default {
  name: 'ToggleSwitchInput',
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    nativeValue: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      newValue: this.value,
    };
  },
  watch: {
    value(value) {
      this.newValue = value;
    },
    newValue(value) {
      if (value === this.nativeValue) {
        this.$emit('input', value);
      }
    },
  },
};
</script>
<template>
  <input
    :id="id"
    :class="{ checked: value === nativeValue }"
    :name="name"
    :value="nativeValue"
    v-model="newValue"
    type="radio"
  >
</template>
